/**
 * AustraliaStateIcon (v3 — 2026-03-02)
 * ─────────────────────────────────────────────────────────────
 * Real state silhouette PNGs supplied by the client. Each icon is
 * a solid black state map (transparent background) served from
 * /public/state-icons/.
 *
 * v3 changes:
 *  - Rendered via CSS `mask-image` so the silhouette is filled with
 *    `currentColor` (i.e. whatever `text-*` colour the parent sets).
 *    This lets the icons render white on the green chip and black on
 *    white surfaces without needing two sets of PNGs.
 *  - PNGs downsized from ~1200px / 800 KB each to 128px / ~15 KB each
 *    (98 % reduction). Loaded eagerly + high fetch priority since
 *    the SA icon is above the fold in the header chip.
 */
const STATE_FILE = {
  SA: 'south-australia.png',
  VIC: 'victoria.png',
  NSW: 'new-south-wales.png',
  QLD: 'queensland.png',
  WA: 'western-australia.png',
  TAS: 'tasmania.png',
  NT: 'northern-territory.png',
  ACT: 'australian-capital-territory.png',
};

const AustraliaStateIcon = ({ state = 'SA', className = 'w-4 h-4', style, ...rest }) => {
  const file = STATE_FILE[state] || STATE_FILE.SA;
  const url = `/state-icons/${file}`;
  return (
    <span
      role="img"
      aria-hidden="true"
      className={`inline-block ${className}`}
      style={{
        backgroundColor: 'currentColor',
        WebkitMaskImage: `url(${url})`,
        maskImage: `url(${url})`,
        WebkitMaskRepeat: 'no-repeat',
        maskRepeat: 'no-repeat',
        WebkitMaskPosition: 'center',
        maskPosition: 'center',
        WebkitMaskSize: 'contain',
        maskSize: 'contain',
        ...style,
      }}
      {...rest}
    />
  );
};

export default AustraliaStateIcon;
